module.exports = __webpack_public_path__ + "img/reference22.d2cdb80a.jpg";